import { css } from '@emotion/react'
import { Theme } from 'src/ui/style/Theme'
import '../../../node_modules/minireset.css/minireset.css'

export const createModalStyle = (th: Theme) => css`
    .modal-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    } 
    
    .modal {
        background-color: ${th.colors.white};
        padding: ${th.spacing.md};
        width: auto;
        height: 50%;
        max-width: 500px;
        position: relative;
    }
}
`
